const SHARE_LINKS_API = '/sitecore/api/ssc/rw/isagenix/sharelinksapi';

function GetRequestVerificationToken() {
    return $('input[name="__RequestVerificationToken"]').val();
}

export async function GetManageShareLinks(request) {
    const token = GetRequestVerificationToken();
    const url = `${SHARE_LINKS_API}/GetManageShareLinks`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function GetManageShareLinksMarkets() {
    const token = GetRequestVerificationToken();
    const url = `${SHARE_LINKS_API}/GetManageShareLinksMarkets`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json'
    });
}

export async function GetPackComponents(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${SHARE_LINKS_API}/GetPackComponents`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function SaveIsFavoriteToShareLink(shareLinkId, isFavorite) {
    const token = GetRequestVerificationToken();
    const url = `${SHARE_LINKS_API}/SaveIsFavoriteToShareLink`;
    const request = {
        shareLinkId,
        isFavorite
    };

    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function DeleteShareLinks(shareLinkIds) {
    const token = GetRequestVerificationToken();
    const url = `${SHARE_LINKS_API}/DeleteShareLinks`;

    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(shareLinkIds)
    });
}
